import React from 'react'
import { useParams } from 'react-router-dom';

const Rules = () => {
    const { seriesId } = useParams();

    return (
        <div>{seriesId} Seris Rules</div>
    )
}

export default Rules